var _path, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUserWelcome = function SvgUserWelcome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    width: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.738 21 13 26.314l5.514-.045 5.95-4.039z",
    fill: "#d14124"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3d3935"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.668 14.989C18.835 16.658 17.502 18 16.005 18s-2.83-1.342-3.664-3.011H12a1 1 0 0 1-1-1v-2a1 1 0 0 1 .447-.833C11.52 8.506 12.567 6 16.005 6c3.473 0 4.488 2.51 4.558 5.162.264.18.437.483.437.827v2a1 1 0 0 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 17v3.019l6 2.012V26m-10-9v3.019L8 22.03V26"
  }))));
};
export default SvgUserWelcome;